var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 34.4,
    className: "st0",
    width: 5.6,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.3,
    y: 22.2,
    className: "st0",
    width: 5.6,
    height: 38.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.5,
    y: 46.6,
    className: "st0",
    width: 5.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,5.2H3c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2H71c1.1,0,2-0.9,2-2v-68C73,6.1,72.1,5.2,71,5.2z M70,74.2H4 v-66H70V74.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,5.2H3c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2H71c1.1,0,2-0.9,2-2v-68C73,6.1,72.1,5.2,71,5.2z M70,74.2H4 v-66H70V74.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1310"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18,34.4v26h5.6v-26H18z M34.3,22.2v38.1h5.6V22.2H34.3z M50.5,46.6v13.8h5.6V46.6H50.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/_icon_dashboard.32ae90b0c7885a53d7310963edce462d.svg";
export { ForwardRef as ReactComponent };